<div *ngIf="!printAvailable" class="not-allowed-print print">
  <i class="fa fa-file-text-o" aria-hidden="true"></i>
  <h4>The document could not be printed</h4>
</div>
